<template>
    <v-tooltip left>
        <template v-slot:activator="{ on }">
            <v-btn
                fab
                dark
                v-on="on"
                v-if="checkPermissions()"
                small
                @click.prevent="openModal()"
                class="buttons--add margin--1 mr-2"
            >
                <v-icon small>mdi-email-fast</v-icon>
            </v-btn>
        </template>
        <span>{{ $t('service-info:sendMail') }}</span>
    </v-tooltip>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getOperationLockDetails',
            'getProfileDetails',
            'getOperationLockRegistry',
        ]),
    },
    methods: {
        openModal() {
            this.$emit('openConfirmModal')
        },
        checkPermissions() {
            if (
                this.getProfileDetails.isAdmin ||
                this.getOperationLockRegistry.currentMenager.mail ==
                    this.getProfileDetails.mail ||
                this.getOperationLockDetails.createdBy.mail ==
                    this.getProfileDetails.mail
            ) {
                return true
            }
            return false
        },
    },
}
</script>
